var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.3074C14.5912 11.3074 16.6993 9.19932 16.6993 6.60818C16.6993 4.01696 14.5912 1.90894 12 1.90894C9.40881 1.90894 7.30078 4.01696 7.30078 6.60818C7.30078 9.19932 9.40889 11.3074 12 11.3074ZM12 3.43455C13.75 3.43455 15.1737 4.85827 15.1737 6.60818C15.1737 8.35809 13.75 9.78181 12 9.78181C10.25 9.78181 8.8264 8.35809 8.8264 6.60818C8.8264 4.85827 10.2501 3.43455 12 3.43455Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.9091C8.1402 11.9091 5 15.0493 5 18.9091V21.3284C5 21.7497 5.34152 22.0912 5.76279 22.0912H18.2371C18.6584 22.0912 19 21.7497 19 21.3284V18.9091C19 15.0493 15.8599 11.9091 12 11.9091ZM6.52562 20.5656V18.9091C6.52562 15.8905 8.98139 13.4347 12 13.4347C15.0186 13.4347 17.4744 15.8905 17.4744 18.9091V20.5656H6.52562Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d59a4c0faeecf0c82f7af3dda0553aea.svg";
export { ForwardRef as ReactComponent };